// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__main[data-v-7355df6c]{font-size:18px;font-weight:400;line-height:1.44;letter-spacing:normal}.text__main.bold[data-v-7355df6c]{font-weight:700}@media (max-width:575.98px){.text__main.adaptive[data-v-7355df6c]{font-size:16px;line-height:1.33}}", ""]);
// Exports
module.exports = exports;
